export default function ProductDetailLoading() {
  const imageColors = Array(5).fill(null);

  return (
    <div className="product-detail-loading">
      <div className="product-detail-links-container">
        <div className="product-detail-image" />
        <div className="product-detail-logo" />
        <div className="product-detail-title" />
        <div className="product-detail-code" />
        <div className="product-detail-website-links" />
      </div>
      <div className="product-detail-main-content-container">
        <div className="product-detail-details-dropdown" />
        <div className="product-detail-stock-selector" />
        <div className="product-detail-image-selector-container">
          {imageColors.map((_, rowIndex) => (
            <div key={rowIndex} className="product-detail-image-selector" />
          ))}
        </div>
      </div>
    </div>
  );
}
